export const DEFAULT_LOCALE = "de-DE";

export const DEFAULT_CURRENCY = "EUR";

export enum StatusColor {
  GOLD = "gold",
  GREEN = "green",
  ORANGE = "orange",
  PURPLE = "purple",
  GRAY = "gray",
  RED = "red",
}

export const DISPLAY_DATE_FORMAT = "DD.MM.YYYY";
export const DISPLAY_DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";
export const SAVE_DATE_FORMAT = "YYYY-MM-DD";
